import { TranslationsObject } from "@genericTypes/sharedTypes";
import { GQLPosts, GQLUrls } from "@gql/types/gql";
import { translate } from "@helpers/translationObjectFormatter";
import { useQuery } from "@tanstack/react-query";
import React, { useState } from "react";
import styles from "./styles.module.scss";
import { formatTimestamp, resolveURL } from "@lib/sharedUtils";
import useWindowSize from "@hooks/useWindowSize";
import { titleDecoder } from "@lib/sharedUtils";

export interface INewsByTags {
    [tag: string]: GQLPosts[];
}

const NewsByTags = () => {
    const { data: newsByTags } = useQuery<INewsByTags>(["newsByTags"]);
    const tags = Object.keys(newsByTags ?? {});
    const { width } = useWindowSize();
    const [selectedTag, setSelectedTag] = useState(tags?.[0] ?? "automotive");
    const { data: translations } = useQuery<TranslationsObject>([
        "translations",
    ]);
    return (
        <div className="flex flex-col gap-10 my-20">
            <div className="flex items-center justify-between">
                <h2 className="font-bold text-4xl">
                    {translate(translations, "several_news_latestNews")}
                </h2>
                {width > 640 && (
                    <a
                        href={`/news/tag/${selectedTag}`}
                        className="font-semibold"
                    >
                        {translate(
                            translations,
                            "several_general_showMoreButton",
                        )}
                    </a>
                )}
            </div>
            <div className="flex flex-col gap-8">
                {tags && tags.length > 0 && (
                    <div
                        className={`flex items-center gap-10 font-medium text-lg border-b border-gray-300 overflow-auto`}
                    >
                        {tags.map((tag) => (
                            <div
                                key={tag}
                                onClick={() => setSelectedTag(tag)}
                                className={`cursor-pointer ${
                                    tag === selectedTag
                                        ? styles["selected-tag"]
                                        : ""
                                } ${
                                    tag === "b2b" ? "uppercase" : "capitalize"
                                }`}
                            >
                                {tag}
                            </div>
                        ))}
                    </div>
                )}
                {newsByTags && (
                    <div className="flex flex-col sm:flex-row gap-4 sm:gap-8">
                        {newsByTags &&
                            newsByTags?.[selectedTag] &&
                            newsByTags[selectedTag].length > 0 && (
                                <div className="grid grid-rows-1 md:grid-cols-2 w-full">
                                    {newsByTags[selectedTag].map((item) => (
                                        <a
                                            key={item.title}
                                            href={resolveURL(
                                                item.url as GQLUrls,
                                            )}
                                            className="flex items-center gap-4 min-h-[130px] sm:min-h-[160px] hover:no-underline"
                                        >
                                            <div className="w-full max-w-[150px]">
                                                <img
                                                    src={
                                                        item.image
                                                            ?.fullPath as string
                                                    }
                                                    alt={item.title as string}
                                                />
                                            </div>
                                            <div className="flex flex-col gap-2">
                                                <div className="text-gray-500 text-xs">
                                                    {formatTimestamp(
                                                        item.createdAt as string,
                                                    )}
                                                </div>
                                                <div className="w-full max-w-[350px] text-black font-bold text-xs sm:text-lg">
                                                    {titleDecoder(
                                                        item.title ?? "",
                                                    )}
                                                </div>
                                                <div className="text-sm">
                                                    {translate(
                                                        translations,
                                                        "several_general_readMoreButton",
                                                    )}
                                                </div>
                                            </div>
                                        </a>
                                    ))}
                                </div>
                            )}
                    </div>
                )}
            </div>
            {width < 640 && (
                <a
                    href={`/news/tag/${selectedTag}`}
                    className="font-semibold text-center"
                >
                    {translate(translations, "several_general_showMoreButton")}
                </a>
            )}
        </div>
    );
};

export default NewsByTags;
